import React, { useState, useEffect } from "react";
import Slider from "react-slick";

import { navigate } from "gatsby";

import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import CardBook from "../../atoms/card-book/cardBook";
import Button from "../../atoms/button/button";

import "./bookSlider.scss";
interface BookSliderInterface {
  books: any;
  gtmClass: string;
  tab?: any;
}

const BookSlider = (props: BookSliderInterface) => {
  const { books, gtmClass, tab,  } = props;
  const [sliderIndex, setSliderIndex] = useState(0);
  const [slider, setSlider] = useState<any>();
  const [sliderIndexM, setSliderIndexM] = useState(0);
  const [sliderM, setSliderM] = useState<any>();
  const [booksToShow, setBooksToShow] = useState([]);
  const { window, isBrowser } = useBrowserMode();

  useEffect(() => {
    if (isBrowser) {
      if (window.screen.width < 340) {
        setBooksToShow(books.slice(0, 4));
      } else if (window.screen.width < 501) {
        setBooksToShow(books.slice(0, 10));
      } else {
        setBooksToShow(books)
      }
    }
  }, [books]);

  const goToNext = () => {
    slider.slickGoTo(sliderIndex + 4);
  };

  const goToBack = () => {
    slider.slickGoTo(sliderIndex - 4);
  };

  const isActiveNext = (_true: any, _false: any) => {
    return sliderIndex < booksToShow.length - 4 ? _true : _false;
  };

  const isActiveBack = (_true: any, _false: any) =>
    sliderIndex > 0 ? _true : _false;

  // Funciones para mobile
  const goToNextM = () => {
    sliderM.slickGoTo(sliderIndexM + 1);
  };

  const goToBackM = () => {
    sliderM.slickGoTo(sliderIndexM - 1);
  };

  const isActiveNextM = (_true: any, _false: any) => {
    return sliderIndexM < booksToShow.length - 1 ? _true : _false;
  };

  const isActiveBackM = (_true: any, _false: any) =>
    sliderIndexM > 0 ? _true : _false;

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4.5,
    slidesToScroll: 4,
    beforeChange: (_: number, next: number) => setSliderIndex(next),
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          centerMode: false,
          slidesToShow: 3.2,
          slidesToScroll: 3,
        },
      },
    ]
  };
  const settingsM = {
    className: "center",
    centerPadding: "20%",
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (_: number, next: number) => setSliderIndexM(next),
    responsive: [
      {
        breakpoint: 960,
        settings: {
          centerMode: false,
          slidesToShow: 3.85,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3.5,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 2.2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 340,
        settings: {
          slidesToShow: 1.75,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const handleBookMobile = () => {
    let booksAux = Array(0);
    const limit = booksToShow.length > 10 ? 10 : booksToShow.length
    for (let i = 0; i < limit; i++) {
      if (tab && i === limit-1) {
        booksAux.push(<div className="card__seeAll">
        <Button
          type='button'
          classname='primary'
          text='Ver todo'
          isDisabled={false}
          onClickAction={seeAll}
        /></div>);
      } else {
        booksAux.push(<CardBook book={booksToShow[i]} key={i} gtmClass={gtmClass} />);
      }
    }
    return booksAux;
  };

  const renderExtraCards = (slides: number) => {
    const toReturn: any = [];
    for (let i = 0; i < (slides - booksToShow.length); i++) {
      toReturn.push(<div className="a-card" key={i}></div>);
    }
    return toReturn;
  }

  const seeAll = () => {
    navigate(`/ver-todo/?title=${tab === 0 ? "Encuentra libros online" : tab === 1 ? "Encuentra tu favorito en nuestra biblioteca online" : tab === 3 ? "Todos los audiolibros" : ""}` +
    `&searchType=filter` +
    `&contentType=Libros` + 
    `&searchParam=word,contentType` +
    `&paramValues=/-${tab === 0 ? "book digital" : tab === 1 ? "book physical" : tab === 3 ? "audiobook" : ""}/-/-/-DATE`,
     {
      state: {},
    });
  };

  const nameButton = (tab) => {
    switch (tab) {
      case 0:
        return 'Ver todos los libros digitales';
      case 1:
        return 'Ver todos los libros físicos'
      case 2:
        return 'Ver todos los Podcasts'
      case 3:
        return 'Ver todos los Audiolibros'  
      default:
        return 'Ver todo'
    }
  }

  return (
    <section className="m-book-slider">
      <div className="hide-on-mobile">
        <div className="m-book-slider__shadow"></div>
        <Slider ref={(_slider) => setSlider(_slider)} {...settings}>
          {booksToShow.map((book, idx) => {
            return (
              <div className="books-desktop" key={idx}>
                {book === "Ver todo" ?
                  <div className="card__seeAll">
                    <Button
                      type='button'
                      classname='primary'
                      text={nameButton(tab)}
                      isDisabled={false}
                      onClickAction={seeAll}
                    /></div> :
                  <CardBook book={book} key={idx} gtmClass={gtmClass} />
                }
              </div>
            );
          })}
          {booksToShow.length < 4 && renderExtraCards(4)}
        </Slider>
        {booksToShow.length > 4 &&
          <>
            <div
              className="arrow-content arrow-content__left"
              onClick={isActiveBack(goToBack, undefined)}
            >
              <div className="arrows">
                <div className="arrows-contain">
                  <div
                    className={isActiveBack(
                      "arrow icon-chevron-left active",
                      "arrow icon-chevron-left"
                    )}
                  />
                </div>
              </div>
            </div>
            <div
              className="arrow-content arrow-content__right"
              onClick={isActiveNext(goToNext, undefined)}
            >
              <div className="arrows">
                <div className="arrows-contain">
                  <div
                    className={isActiveNext(
                      "arrow icon-chevron-right active",
                      "arrow icon-chevron-right"
                    )}
                  />
                </div>
              </div>
            </div>
          </>
        }
      </div>
      <div className="show-on-mobile">
        <Slider ref={(_slider) => setSliderM(_slider)} {...settingsM}>
          {handleBookMobile().map((books) => books)}
          {booksToShow.length < (window.innerWidth <= 500 ? 2 : 3) &&
            renderExtraCards(window.innerWidth <= 500 ? 2 : 3)
          }
        </Slider>
        <div
          className="arrow-content arrow-content__left"
          onClick={isActiveBackM(goToBackM, undefined)}
        >
          <div className="arrows">
            <div className="arrows-contain">
              <div
                className={isActiveBackM(
                  "arrow icon-chevron-left active",
                  "arrow icon-chevron-left"
                )}
              />
            </div>
          </div>
        </div>
        <div
          className="arrow-content arrow-content__right"
          onClick={isActiveNextM(goToNextM, undefined)}
        >
          <div className="arrows">
            <div className="arrows-contain">
              <div
                className={isActiveNextM(
                  "arrow icon-chevron-right active",
                  "arrow icon-chevron-right"
                )}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookSlider;
